import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import AuthCallback from "@/components/landing/AuthCallback";
import Landing from "@/pages/Landing";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter basename={process.env.NODE_ENV === "production" ? process.env.PUBLIC_URL : "/"}>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
